// ConsentContext.ts
import React, { createContext, useContext } from 'react';

export interface ConsentSettings {
    analytics_storage: 'granted' | 'denied';
    ad_storage: 'granted' | 'denied';
    ad_user_data: 'granted' | 'denied';
    ad_personalization: 'granted' | 'denied';
    timestamp?: string;
}

interface ConsentContextType {
    consent: ConsentSettings | null;
    confirmConsent: () => Promise<void>;
    hasConsented: boolean;
    showBanner: boolean;
    toggleConsentDetail: (type: 'analytics' | 'advertising') => void;
    analyticsDetails: boolean;
    advertisingDetails: boolean;
    // New properties for partial consent
    partialConsent: ConsentSettings;
    toggleConsentSetting: (setting: keyof ConsentSettings) => void;
}

// Export the context so it can be used elsewhere if needed
export const ConsentContext = createContext<ConsentContextType | undefined>(undefined);

export const useConsent = () => {
    const context = useContext(ConsentContext);
    if (!context) {
        throw new Error('useConsent must be used within a ConsentProvider');
    }
    return context;
};